<template>
  <div id="page-container">
    <!-- <page-header :title="title" :container-class="containerClass" /> -->
    <div
      class="page-section"
      :class="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL ? 'jobs_container_low_pad' : 'jobs_container'"
    >
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt flex-wrap">
          <h2>Career Paths in Universities</h2>

          <!-- <small class="text-muted text-headings text-uppercase mr-1 d-sm-block" v-if="!isMobSmallScreen"
              >Sort by</small
            > -->
          <!-- <b-dropdown variant="link text-black-70" right no-caret>
              <template #button-content>
                <span>{{ $t(`studentEmpSortOptions.${ordering}`) }}<i class="fas fa-sort ml-1"></i></span>
              </template>

              <b-dropdown-item :active="ordering === 'name'" @click="onSortChange({ sortBy: 'name' })"
                >Name</b-dropdown-item
              >
              <b-dropdown-item :active="ordering === 'company_type'" @click="onSortChange({ sortBy: 'company_type' })"
                >Industry</b-dropdown-item
              >
              <b-dropdown-item :active="ordering === 'city'" @click="onSortChange({ sortBy: 'city' })"
                >Location</b-dropdown-item
              >
            </b-dropdown> -->

          <!-- <b-form-group> -->
          <div class="col-lg d-flex flex-wrap justify-content-end">
            <div class="col-lg-4" :class="{ 'pl-0': isMobSmallScreen }">
              <v-select
                id="offered_programs"
                class="form-control v-select-custom"
                label="name"
                v-model="career"
                :reduce="(cr) => cr.id"
                placeholder="Search Careers..."
                :options="allCareers"
                :loading="areCareersLoading"
                @input="onSearch"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                </template>
                <template slot="option" slot-scope="option">
                  <span>{{ option.name }}</span>
                </template>
              </v-select>
            </div>
            <!-- </b-form-group> -->
          </div>
        </div>

        <page-separator
          :title="
            !isLoading
              ? `showing ${totalUnis ? `${pageFromCount}-${pageToCount}` : 0} of ${totalUnis} universities`
              : ''
          "
        />

        <div class="d-flex justify-content-center" v-if="!totalUnis && !isLoading">
          <div class="card card-block card-stretch card-height col-md-8">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Universities Found</h4>

              <p class="text-muted">Couldn't find any Universities.</p>

              <!-- <a href="#" @click.prevent="" class="btn btn-primary mt-2"> Sample Button </a> -->
            </div>
          </div>
        </div>

        <b-skeleton-wrapper :loading="isLoading" v-else>
          <template #loading>
            <div class="row card-group-row mb-lg-12pt home-card">
              <div class="col-md-6 col-lg-6 card-group-row__col" v-for="item in [1, 2]" :key="item">
                <div class="card overlay--show card-lg overlay--primary-dodger-blue card-group-row__card myBox">
                  <div class="card-header d-flex align-items-center">
                    <a href="#" @click.prevent class="card-title flex mr-12pt">
                      <b-skeleton width="100%"></b-skeleton
                    ></a>
                    <!-- <a href="#" @click.prevent class="" data-placement="bottom">
                      <b-skeleton width="100%"></b-skeleton
                    ></a> -->
                  </div>
                  <div class="card-body flex text-center d-flex flex-column justify-content-center">
                    <a
                      href="#"
                      @click.prevent
                      class="avatar avatar-xl overlay js-overlay overlay--primary rounded p-relative o-hidden mb-16pt align-self-center"
                      style="border: 1px solid #dfe2e6;id #dfe2e6;id #dfe2e6;pxl"
                    >
                      <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                    </a>
                    <div class="flex">
                      <p class="text-70 measure-paragraph">
                        <b-skeleton width="100%"></b-skeleton>
                        <b-skeleton width="55%"></b-skeleton>
                        <b-skeleton width="70%"></b-skeleton>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="row card-group-row mb-lg-12pt home-card">
            <div class="col-md-6 col-lg-6 card-group-row__col" v-for="uni in unis" :key="uni.id">
              <div
                class="card overlay--show card-lg overlay--primary-dodger-blue card-group-row__card myBox clickable-item"
                @click.prevent="openSite(uni)"
              >
                <div class="card-header d-flex align-items-center">
                  <a href="#" @click.prevent class="card-title flex mr-12pt">
                    {{ uni.name }}
                  </a>
                  <a href="#" @click.prevent class="" data-placement="bottom">{{ uni.city }}, {{ uni.state }}</a>
                </div>
                <div class="card-body flex text-center d-flex flex-column align-items-center justify-content-center">
                  <a
                    href="#"
                    @click.prevent
                    class="avatar avatar-xl overlay js-overlay overlay--primary rounded p-relative o-hidden mb-16pt"
                    style="border: 1px solid #dfe2e6;id #dfe2e6;id #dfe2e6;pxl"
                  >
                    <img
                      class="avatar-img rounded"
                      :src="uni.small_logo_url || DefaultLogo"
                      width="160"
                      height="auto"
                      style="object-fit: contain !important"
                    />
                  </a>

                  <div class="flex">
                    <p class="text-70 measure-paragraph">
                      <span v-if="trim(uni.short_bio)">{{
                        truncate(trim(uni.short_bio), {
                          length: 240,
                          separator: /,? +/,
                        })
                      }}</span>
                      <i v-else>{{ uni.name }} has not added any bio yet.</i>
                    </p>
                  </div>

                  <div class="card-button" v-if="get(uni.offered_programs, 'length')">
                    <ul>
                      <li v-for="career in getProgramCareers(uni.offered_programs)" :key="career.id">
                        <a href="#" @click.prevent
                          ><span class="material-icons icon-16pt text-100">check</span>{{ career }}</a
                        >
                      </li>
                    </ul>
                  </div>

                  <a
                    :href="getRedirectUrl(uni)"
                    target="blank"
                    class="btn btn-dark"
                    :class="isMobSmallScreen ? 'w-100' : 'w-75'"
                    ><md-icon class="mr-1">open_in_new</md-icon> Take Assessment</a
                  >
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <pagination
          v-if="totalUnis > unis.length"
          v-model="currentPage"
          :total-rows="totalUnis"
          :per-page="perPage"
          @change="onPageChange"
          aria-controls="orgs-table"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import PageHeader from '@/components/Ui/PageHeader.vue';
import { debounce, flatten, get, trim, truncate, uniq } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import Page from '@/components/Page.vue';
import Pagination from '@/components/Ui/Pagination.vue';
import DefaultLogo from '@/assets/images/logos/logo_icon.png';
import { USER_ROLE_TYPES } from '@/common/constants';
import PageSeparator from '@/components/Ui/PageSeparator.vue';

export default {
  components: { Pagination, PageSeparator },
  extends: Page,

  data() {
    return {
      DefaultLogo,
      USER_ROLE_TYPES,

      title: 'Universities',

      isLoading: true,
      partnerStatusesLoading: true,

      perPage: 14,
      currentPage: 1,
      totalUnis: 0,
      allCareers: [],
      unis: [],
      areCareersLoading: false,
      pageFromCount: 0,
      pageToCount: 0,
      searchTerm: '',
      career: '',
      ordering: 'name',

      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),

    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Universities', active: true },
      ];
    },

    isMobSmallScreen() {
      return this.windowWidth <= 500;
    },
  },

  methods: {
    ...mapActions('uni', ['getAllUniversitiesForStd']),
    ...mapActions('careerPreference', ['getAllCareerPreferences']),
    get,
    trim,
    truncate,
    async fetchCareerPreferences() {
      this.areCareersLoading = true;

      const response = await this.getAllCareerPreferences({});
      this.allCareers = response.data;

      this.areCareersLoading = false;
    },
    async fetchUnis(pageNum = 1, params = {}) {
      this.isLoading = true;
      document.getElementById('page-container').scrollIntoView();
      try {
        const response = await this.getAllUniversitiesForStd({
          limit: this.perPage,
          offset: (pageNum - 1) * this.perPage,
          ...(this.career && { offered_programs__offered_careers__id: this.career }),
          ...params,
        });
        this.unis = response.data.results || [];
        this.currentPage = pageNum;
        this.totalUnis = response.data.count || 0;

        this.pageFromCount = (this.currentPage - 1) * this.perPage + 1;
        const uniCount = response.data.results ? get(response.data, 'results.length', 0) : 0;
        this.pageToCount = this.pageFromCount + uniCount - 1;
      } catch (e) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchUnis(pageNum);
    },

    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchUnis();
    },

    onSearch() {
      this.debouncedSearchUnis(this);
    },

    debouncedSearchUnis: debounce((vm) => {
      vm.fetchUnis();
    }, 500),

    openSite(uni) {
      window.open(this.getRedirectUrl(uni), '_blank');
    },

    getRedirectUrl(uni) {
      return `${process.env.VUE_APP_UNI_SPONSORED_URL}/${uni.slug}/career-assessment`;
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    getProgramCareers(programs) {
      return uniq(flatten(programs.map((program) => program.offered_careers.map((career) => career.name))));
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.fetchCareerPreferences();
    this.fetchUnis();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.card-button ul li a {
  padding: 5px 7px !important;
}
</style>
